import {FormControl, ValidatorFn, AbstractControl} from '@angular/forms';
import {HomeService} from '../../components/home/services/home.service'
/**
 * Custom Validators
 *
 * @author Dhanya
 */
export class AzidValidators {
    /**
     * Get validator message by using code
     *
     * @param {string} code
     * @param {any} [additionalParams]
     * @returns {any}
     */
    constructor(public homeService: HomeService){

    }
    static getValidatorErrorMessage(code: string, additionalParams?: any): string {

        let inValidFieldValue: string = 'inValidNumber';


        let config = {
            'inValidNumber': inValidFieldValue,

        };
        return config[code];
    }


    /**
     * Check whether the input field is valid.
     *
     * @param plate field value text.
     * @returns {boolean} true if valid, otherwise false.
     */
    static isSetupCalculatorValid(plate: string): boolean {
        if (!plate) {
            // No value in control.
            return false;
        } else {
            // to be valid field value must contain both number and character (Rp , Tahun , %).
           if (/\d/.test(plate) && /[a-zA-Z]/.test(plate)){
                return true;
            }

            // to be valid field value must contains at least a number.
            if (plate.search(/\d/) < 0) {
                // No number found.
                return false;
            }

            // Only return true if all previous checks passed.
            return true;
        }
    }
  /**
   * Check whether the input field is valid.
   *
   * @param plate field value text.
   * @returns {boolean} true if valid, otherwise false.
   */
  static isSetupMoneyValid(plate: number): boolean {
    if (plate <= 0) {
      // No value in control.
      return false;
    } else {

      // Only return true if all previous checks passed.
      return true;
    }
  }

    /**
     * Simple validation for field value format
     *
     * @param {control} FormControl
     * @returns {(control:FormControl)=>{}}
     */
    static isSetupCalculatorValidWithFormControl(control: FormControl) {
        // REGION CONSTANTS {
        class ReturnClass {
            public inValidFieldValue: boolean;
        }

        let validValue: ReturnClass = undefined;
        let invalidValue: ReturnClass = {inValidFieldValue: true};
        let plate: string = control.value;
        if (AzidValidators.isSetupCalculatorValid(plate)) {
            return validValue;
        } else {
            return invalidValue;
        }
    }
  /**
   * Simple validation for field value format
   *
   * @param {control} FormControl
   * @returns {(control:FormControl)=>{}}
   */
  static isSetupMoneyFieldValidWithFormControl(control: FormControl) {
   // AzidValidators.getUserDateOfBirth();
    // REGION CONSTANTS {
    class ReturnClass {
      public inValidFieldValue: boolean;
    }

    let validValue: ReturnClass = undefined;
    let invalidValue: ReturnClass = {inValidFieldValue: true};
    let plate: number = control.value;
    if (AzidValidators.isSetupMoneyValid(plate)) {
      return validValue;
    } else {
      return invalidValue;
    }
  }
  /**
   * Simple validation for field value format
   *
   * @param {control} FormControl
   * @returns {(control:FormControl)=>{}}
   */
  static checkLifeExpected(pensionAge): ValidatorFn {
    return (control: AbstractControl): {[key: string]: any} => {

      console.log('pensionAge.'+ pensionAge);
      //// console.log('suminsured value price.'+ control.value);
      class ReturnClass {
        public inValidFieldValue: boolean;
      }
      let validValue: ReturnClass = undefined;
      let invalidValue: ReturnClass = {inValidFieldValue: true};
      let retireAge = (pensionAge).replace(/[^0-9]/g,'');

      if (control.value > parseInt(retireAge)) {
        return validValue;
      } else {
        return invalidValue;
      }

    };
  }

}
